/* eslint-disable complexity */
import CardWrapper from '../wrapper/card';
import CustomInput from '../reusable/input';
import { formatTimeUptoNow } from '../../helper';
import { gray } from '../../theme/themePrimitives';
import { settingSelectedFolderForEdit } from '../../redux/slices/folder';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import { ChatBubbleOutlineOutlined, DeleteOutlineOutlined, DocumentScannerOutlined, EditOutlined, Person2Outlined, PersonAddAlt1Outlined, PostAddOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';

const EditFolderComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [commentValue, setCommentValue] = useState<string>('');
    const { selectedFolderForEdit } = useSelector((state: RootState) => state.folder);
    return (
        <Box borderTop={`1px solid ${gray[100]}`} pt={1} >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Button variant="text" color="secondary" onClick={() => dispatch(settingSelectedFolderForEdit(null))}>&larr; Back</Button>
                <Typography variant="h5" color="info">{selectedFolderForEdit?.name}</Typography>
                <Box display="flex">
                    <IconButton color="primary">
                        <EditOutlined />
                    </IconButton>
                    <IconButton color="error">
                        <DeleteOutlineOutlined />
                    </IconButton>
                </Box>
            </Box>
            <Typography variant="body1" color="textDisabled" gutterBottom>Created {selectedFolderForEdit?.created_at && formatTimeUptoNow(selectedFolderForEdit.created_at)}  .  Last Modified {selectedFolderForEdit?.updated_at && formatTimeUptoNow(selectedFolderForEdit.updated_at)}</Typography>
            <Divider />
            <Box display="flex" gap="10px" mt={2}>
                <CardWrapper>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" gap="10px"><Person2Outlined /><Typography variant="h6" color="textSecondary"> Contributors</Typography></Box>
                        <Button variant="outlined" onClick={() => null} startIcon={<PersonAddAlt1Outlined />}>Assign Users</Button>
                    </Box>
                    <Box display="flex" flexDirection="column" gap="20px" minHeight="35vh" maxHeight="35vh" overflow="auto" pt={1}>
                        {/* {
                    selectedTaskItem?.files?.map((file, index) => <Box key={index}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center" gap="10px">
                                <DocumentScannerOutlined />
                                <Box>
                                    {file.file_name}<br />
                                    0 MB
                                </Box>
                            </Box>
                            <Box>CREATED AT:</Box>
                        </Box>
                    </Box>)
                } */}
                    </Box>
                </CardWrapper>
                <CardWrapper>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center" gap="10px"><DocumentScannerOutlined /><Typography variant="h6" color="textSecondary"> Tasks</Typography></Box>
                        <Button variant="outlined" onClick={() => null} startIcon={<PostAddOutlined />}>Assign Tasks</Button>
                    </Box>
                </CardWrapper>
                <CardWrapper>
                    <Box display="flex" alignItems="center" mb={1} gap="10px"><ChatBubbleOutlineOutlined /><Typography variant="h6" color="textSecondary"> Comments</Typography></Box>
                    <CardWrapper><Box display="flex" flexDirection="column-reverse" minHeight="35vh" maxHeight="35vh" overflow="auto" gap="20px" pt={1}>
                        {/* {selectedTaskItem?.comments?.map((comment, index) => <Box key={index}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center" gap="10px"><VerifiedUser />{comment.comment}</Box>
                            Created at:
                        </Box>
                    </Box>)
                    } */}
                    </Box>
                    </CardWrapper>
                    <Box display="flex" alignItems="center" gap="10px" mt={1}>
                        <CustomInput
                            fullWidth
                            value={commentValue}
                            onChange={(e) => setCommentValue(e.target.value)}
                            placeholder="Add a comment"
                        />
                        <Button variant="contained" disabled={commentValue.trim() === ''} onClick={() => null}>
                            Send
                        </Button>
                    </Box>
                </CardWrapper>
            </Box>
        </Box>
    );
};

export default EditFolderComponent;